export default function CivilityForm({ onChange, value, required, disabled }) {
    return (
        <div className="form-input">
            <label htmlFor="civility" className={required && "required"}>Civilité</label>
            <select name="civility" onChange={onChange} value={value || ""} required={required} disabled={disabled}>
                <option name="civility" disabled value="">Sélectionnez une civilité</option>
                <option name="civility" value="MME">Madame</option>
                <option name="civility" value="M">Monsieur</option>
            </select>
        </div>
    )
}